module.exports = function() {
  return new Worker(__webpack_public_path__ + "new-agent/static/js/time.worker.7d04157.js");
};